/* Twosisters - phone-only "Get 10% off" side tab. Fixed 2 Oct 2026.
   Loaded before ts-chat.js. It sets window.__tsOfferTab, so the older copy inside ts-chat.js does not run.
   Fix: the Attentive frame only counts as the small teaser when its height is set in pixels (120px or less).
   The full-screen sign-up pop-up has height "100%"; the old check read that as 100 and hid the pop-up,
   which left the page scroll-locked with nothing to close. */
(function () {
  'use strict';
  if (window.__tsOfferTab) return;
  window.__tsOfferTab = true;
  var css = '@media (max-width:767px){' +
    'iframe#attentive_creative.ts-att-teaser{left:0 !important;right:auto !important;bottom:auto !important;top:52vh !important;transform-origin:0 100% !important;transform:rotate(90deg) !important;opacity:0.01 !important}' +
    '.ts-offer-tab.is-on{display:flex}' +
    '}' +
    '.ts-offer-tab{position:fixed;left:0;top:calc(52vh + 60px);z-index:2147483647;pointer-events:none;writing-mode:vertical-rl;transform:rotate(180deg);background:rgb(243,229,245);color:#000;font-family:Jost,sans-serif;font-size:14px;font-weight:400;letter-spacing:.04em;line-height:1;padding:0 12px;height:150px;display:none;align-items:center;justify-content:center;border-radius:0 12px 12px 0;box-shadow:0 2px 10px rgba(0,0,0,.12)}';
  function isTeaser(f) {
    if (!f) return false;
    var hs = String(f.style.height || '');
    if (!/px$/.test(hs)) return false;
    var h = parseFloat(hs) || 0;
    return h > 0 && h <= 120 && f.style.visibility !== 'hidden' && f.style.opacity !== '0';
  }
  function init() {
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var tab = document.createElement('div');
    tab.className = 'ts-offer-tab'; tab.setAttribute('aria-hidden', 'true'); tab.textContent = 'Get 10% off';
    document.body.appendChild(tab);
    setInterval(function () {
      var f = document.getElementById('attentive_creative');
      var teaser = isTeaser(f);
      if (f) f.classList.toggle('ts-att-teaser', teaser);
      tab.classList.toggle('is-on', teaser);
    }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
